// extracted by mini-css-extract-plugin
module.exports = {"addToCartButton":"addtocart_addToCartButton__3Py-u"};